/** Premier délai de reconnexion du websocket. */
export const RECONNECT_INITIAL_DELAY_MS = 1000;
/** Plafond : un rolling update du broker dure ~15 s, on retente au moins toutes les 30 s. */
export const RECONNECT_MAX_DELAY_MS = 30_000;
/** ±25 % : les navigateurs coupés en même temps ne reviennent pas tous à la même milliseconde. */
const JITTER_RATIO = 0.25;

/**
 * Délai avant la tentative de reconnexion n° `attempt` (1 = première après la coupure) :
 * exponentiel (1 s, 2 s, 4 s…) plafonné à 30 s, avec jitter, sans limite de tentatives.
 */
export function reconnectDelayMs(attempt: number, random: () => number = Math.random): number {
  const exponent = Math.max(0, attempt - 1);
  const base = Math.min(RECONNECT_MAX_DELAY_MS, RECONNECT_INITIAL_DELAY_MS * 2 ** exponent);
  const jittered = base * (1 - JITTER_RATIO + random() * 2 * JITTER_RATIO);
  return Math.min(RECONNECT_MAX_DELAY_MS, Math.round(jittered));
}
